module.exports = __webpack_public_path__ + "static/media/eocene_pulseoxygenetransparent.1e9c172b.png";